<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col lg="12">
                    <b-card>
                        <b-tabs pills card>
                            <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                <b-card-text>
                                    <card>
                                        <div slot="header">
                                            <h3>{{title}} </h3>
                                        </div>
                                        <b-row>
                                            <b-col sm="6">
                                                <base-input :label="language_terms['CODE']" v-model="salechannel.code" :disabled="!is_edit"></base-input>
                                            </b-col>
                                            <b-col sm="6">
                                                <base-input :label="language_terms['NAME']" v-model="salechannel.name" :disabled="!is_edit"></base-input>
                                            </b-col>
                                            <b-col sm="12">
                                                <base-input :label="language_terms['DESP']" v-model="salechannel.desp" :disabled="!is_edit"></base-input>
                                            </b-col>
                                            <b-col sm="6">
                                                <base-input :label="language_terms['BASE_DISCOUNT_PERCENT']" v-model="salechannel.base_listprice_discount_percentage" type="number" :disabled="!is_edit"></base-input>
                                            </b-col>
                                            <b-col sm="6">
                                                <base-input :label="language_terms['MOQ_DISCOUNT_PERCENT']" v-model="salechannel.moq_listprice_discount_percentage" type="number" :disabled="!is_edit"></base-input>
                                            </b-col>
                                        </b-row>
                                    </card>
                                </b-card-text>
                                <div class="floating-bar">
                                    <div class="floating-bar-container" align="center">
                                        <b-button-group>
                                            <b-button class="transparent-btn"  @click="handleEdit" v-if="!is_edit">
                                                <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                            </b-button>
                                            <b-button class="transparent-btn"  @click="saveSaleChannel" v-if="is_edit">
                                                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                            </b-button>
                                            <b-button class="transparent-btn"  @click="handleCancel" v-if="is_edit">
                                                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </div>
                                <!-- <div>
                                    <a href="javascript:void(0)" class="float-button " @click="handleEdit" style="background-color:#2dce89" v-if="!is_edit">
                                        <i class="fa fa-edit  my-float-button" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript:void(0)" class="float-button " @click="handleCancel" style="background-color:#fb6340" v-if="is_edit">
                                        <i class="fa fa-times  my-float-button" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript:void(0)" class="float-button mr-7" @click="saveSaleChannel" style="background-color:#5e72e4" v-if="is_edit">
                                        <i class="fas fa-check my-float-button"></i>
                                    </a>
                                </div> -->
                            </b-tab>
                            <b-tab :title="language_terms['CUSTOMERS'] + ' (' + salechannel.customers_count + ')'" v-if="$route.params.id !='_new'">
                                <b-card-text>
                                    <card>
                                        <div slot="header">
                                            <h3>{{salechannel.code}} </h3>
                                        </div>
                                        <b-row>
                                            <b-col md="11">
                                                    <label class="form-control-label">{{language_terms['CODE']}}</label>
                                                    <multiselect
                                                        :custom-label="customerNameWithCode"
                                                        v-model="selected_customer"
                                                        id="ajax"
                                                        label="name"
                                                        track-by="id"
                                                        placeholder="Type to search"
                                                        open-direction="bottom"
                                                        :options="customers"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :loading="isLoading"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :options-limit="300"
                                                        :limit="50"
                                                        :max-height="600"
                                                        :show-no-results="false"
                                                        :hide-selected="true"
                                                        @search-change="asyncFindCustomer"
                                                        >
                                                    </multiselect>
                                            </b-col>
                                            <b-col lg="1" class='mt-4'>
                                                <base-button  type="primary" class='mt-2' @click.native="addcustomer">
                                                    <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                </base-button>
                                            </b-col>
                                            <b-col lg="12" class="mt-4">
                                                <div>
                                                    <b-table :items="salechannel.customers" :fields="customerTabelFields" head-variant="light" v-if="salechannel.customers.length > 0">
                                                        <template #cell(deleteBtn)="row">
                                                            <base-button icon type="warning" @click="removeCustomer(row.index, row.item)" size="sm" v-if="salechannel.customers.length > 0">
                                                                <i class="fa fa-trash"></i>
                                                            </base-button>
                                                            <!-- <base-button icon type="warning" @click="customizeprice" size="sm" v-if="salechannel.customers.length > 0">
                                                                <i class="fa fa-cog" aria-hidden="true"></i>
                                                            </base-button> -->
                                                        </template>
                                                    </b-table>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </card>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="language_terms['PRODUCT_CATEGORIES'] + ' (' + salechannel.categories_count + ')'" v-if="$route.params.id !='_new'">
                                <b-card-text>
                                    <card>
                                        <div slot="header">
                                            <h3>{{salechannel.code}} </h3>
                                        </div>
                                        <b-row >
                                            <b-col lg="12">
                                                <div>
                                                    <!-- {{salechannel.product_category_prices}} -->
                                                    <el-table :data="salechannel.product_category_prices" style="width: 100%">
                                                        <el-table-column prop="sno" :label="language_terms['SNO']" :min-width="19">
                                                            <template slot-scope="scope">
                                                                <div>{{(scope.$index *1) + 1}}</div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="product_category_code" :label="language_terms['CATEGORY_CODE']" :min-width="35">
                                                            <template slot-scope="scope">
                                                                {{scope.row.product_category_code}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="product_category_name" :label="language_terms['CATEGORY_NAME']">
                                                            <template slot-scope="scope">
                                                                {{scope.row.product_category_name}}
                                                                <!-- <el-input size="small" disabled style="text-align:center" v-model="scope.row.product_category_name"></el-input> -->
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="base_listprice_discount_percentage" :label="language_terms['BASE_DISCOUNT_PERCENT']">
                                                            <template slot-scope="scope">
                                                                <!-- {{scope.row}} -->
                                                                <el-input size="small" style="text-align:center" v-model="scope.row.base_listprice_discount_percentage" type="number">
                                                                </el-input>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="moq_listprice_discount_percentage" :label="language_terms['MOQ_DISCOUNT_PERCENT']">
                                                            <template slot-scope="scope">
                                                                <el-input size="small" style="text-align:center" v-model="scope.row.moq_listprice_discount_percentage" type="number"></el-input>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </card>                                 

                                </b-card-text>
                                <div class="floating-bar">
                                    <div class="floating-bar-container" align="center">
                                        <b-button-group>
                                            <b-button class="transparent-btn"  @click="handleSaveCategories">
                                                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                            </b-button>
                                            <b-button class="transparent-btn"  @click="handleCancel">
                                                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </div>
                                <!-- <div>
                                    <a href="javascript:void(0)" class="float-button"  @click="handleCancel" style="background-color:#fb6340" >
                                        <i class="fa fa-times  my-float-button" aria-hidden="true"></i>
                                    </a>
                                    <a href="javascript:void(0)" class="float-button mr-7" @click="handleSaveCategories" style="background-color:#5e72e4" >
                                        <i class="fas fa-check my-float-button"></i>
                                    </a>
                                </div> -->
                            </b-tab>
                            <b-tab :title="language_terms['CUSTOMIZED_PRICES'] + ' (' + salechannel.customized_prices_count + ')'" v-if="$route.params.id !='_new'">
                                <card>
                                    <div slot="header">
                                        <h3>{{salechannel.code}} </h3>
                                    </div>
                                    <price-setup 
                                        :salechannel_id="salechannel.id" 
                                        :customized_prices="salechannel.customized_prices" 
                                        :code="salechannel.code"
                                        :module="'salechannel'"
                                    ></price-setup>
                                </card>                         
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import priceSetup from '../Components/priceSetup.vue';
import { mapState } from "vuex";
import {Table,TableColumn,Button} from 'element-ui'
import Multiselect from 'vue-multiselect'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import BaseButton from '../../components/BaseButton.vue';
import Tab from '../../components/Tabs/Tab.vue';


export default 
{
    data(){
        return{
            newCategory:{
                default_discount:"",
                moq_discount:"",
                date_from:"",
                date_to:"",
                category:{}

            },
            categories:[],
            selected_category:"",
            headerBgVariant: "primary",
            headerTextVariant: "light",
            addCategoryModal:false,
            title:"",
            isLoading:false,
            is_edit:false,
            customers:[],
            selected_customer:{},
            customerTabelFields: [
                { key: 'code', label: 'Customer Code', terms:'CUSTOMER_CODE'},
                { key: 'name', label: 'Customer Name', terms:'CUSTOMER_NAME' },
                { key: 'deleteBtn', label: 'Action', terms:'ACTION'},
            ],
            loading: false,
            salechannel:{
                code:"",
                name:"",
                desp:"",
                customers:[],
                product_category_prices:[],
                customized_prices:[],
                moq_listprice_discount_percentage:'',
                base_listprice_discount_percentage:''
            }
        }
    },
    computed:{
         ...mapState({
            product_categories: state => state.products.product_categories,
            salechannel_retrieve:state =>state.salechannels.data,
            salechannel_filter: state => state.salechannels.filter,
            salechannel_is_created: state => state.salechannels.is_created,
            salechannel_is_updated: state => state.salechannels.is_updated,
            salechannel_is_deleted: state => state.salechannels.is_deleted,
            salechannel_data: state => state.salechannels.data,
            salechannel_added: state =>state.salechannels.is_customer_added,
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            is_customer_removed: state => state.salechannels.is_customer_removed
         })
    },
    components: {
        priceSetup,
        Multiselect,
        BaseButton,
        Tab,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button

  },
    async mounted()
    {
        if(this.$route.params.id == '_new')
        {
            this.title = this.language_terms['NEW'] + ' ' + this.language_terms['SALE_CHANNEL']
            this.is_edit = true
        } 
        else
        {
            await this.retrieveSaleChannel(this.$route.params.id)
            await this.fetchCategories()
            this.salechannel = this.salechannel_data
            this.title = this.language_terms['SALE_CHANNEL'] + ' (' + this.salechannel.code + ')'
            this.is_edit = false
        }
        this.updateLang()

    },
    watch:{
        language_terms:{
                deep:true,
                handler(val){
                    this.updateLang()
                },
        },
        salechannel_data:
        {
            deep:true,
            handler(){
                this.salechannel = this.salechannel_data
            }
        }
    },
    methods:
    {   
        customizeprice(){
            this.$router.push({ path:'/sales/customized-prices/', query: {salechannel_id:this.salechannel.id,customer_id:this.selected_customer.id}})

        },
        async fetchCategories(){
            this.loading=true
            await this.$store.dispatch("products/fetchAllCategories", {})
            this.loading=false
        },
        async onChangeDateFrom(){

            console.log("onChangeDateFrom")

        },
        async onChangeDateTo(){

            console.log("onChangeDateTo")

        },

        async searchSaleChannels()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.salechannel_filter)
            {
                filter = this.salechannel_filter
            }
            await this.$store.dispatch('salechannels/quickSearch', filter)

            this.loading = false
        },
        async saveSaleChannel ()
        {
            this.isLoading = true
            
            if(this.$route.params.id == '_new')
            {
                await this.createSaleChannel()
            }
            else
            {
                await this.updateSaleChannel()
            }

            this.isLoading = false
        },
        async createSaleChannel()
        {
            await this.$store.dispatch("salechannels/create", this.salechannel)

            if(this.salechannel_is_created)
            {
                await this.searchSaleChannels()
                this.$router.push('/sales/salechannels');
            }
        },
        async updateSaleChannel()
        {
            await this.$store.dispatch("salechannels/update", this.salechannel)

            if(this.salechannel_is_updated)
            {
                await this.searchSaleChannels()
                this.$router.push('/sales/salechannels');
            }
        },
        handleEdit()
        {
            this.is_edit = true
        },
        updateLang(){
            for(let i=0; i<this.customerTabelFields.length;i++)
            {
                let key = this.customerTabelFields[i].terms
                this.customerTabelFields[i].label = this.language_terms[key]
            }

            if(this.$route.params.id == '_new')
            {
                this.title = this.language_terms['NEW'] + ' ' + this.language_terms['SALE_CHANNEL']
            } 
            else
            {
                this.title = this.language_terms['SALE_CHANNEL'] + ' (' + this.salechannel.code + ')'
            }

        },
        handleCancel()
        {
            if(this.$route.params.id == '_new')
                this.$router.push("/sales/salechannels")
            else
                location.reload();
        },
        async handleSaveCategories()
        {
            this.isLoading = true
            //alert("Save")
            let data = {code: this.salechannel.code, salechannel_id:this.salechannel.id, product_categories:this.salechannel.product_category_prices}
            await this.$store.dispatch("salechannels/saveProductCategories", data)

            if(this.salechannel_is_updated)
            {
                await this.retrieveSaleChannel(this.$route.params.id)
                this.salechannel = this.salechannel_data
            }
            this.isLoading = false
        },

        categoryNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        customerNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        async asyncFindCustomer(query) 
        {
            this.isLoading = true;
            let pv = { value: query };
            await axios
                .post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    this.customers = response.data.data;
                } else {
                    this.customers = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                            group: "notify",
                            type: "error",
                            text: error.response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });
                    } 
                    else 
                    {
                        console.log("Problem submitting New Post", error);
                    }
                });
        },
        // async asyncFindCategory(query) 
        // {
        //     this.isLoading = true;
        //     let pv = { value: query };
        //     await axios
        //         .post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader())
        //         .then((response) => {
        //         if (response.data.code == 1) {
        //             this.categories = response.data.data;
        //         } else {
        //             this.categories = [];
        //         }

        //         this.isLoading = false;
        //         })
        //         .catch((error) => {
        //         if (error.response) 
        //         {
        //             Vue.notify({
        //                     group: "notify",
        //                     type: "error",
        //                     text: error.response.data.msg,
        //                     max: 5,
        //                     duration: 5000,
        //                     speed: 300,
        //                 });
        //             } 
        //             else 
        //             {
        //                 console.log("Problem submitting New Post", error);
        //             }
        //         });
        // },

        handleDelete(index, row){
            this.categories.splice(index, 1)  

        },
        async removeCustomer(index, row){
           if(row)
           {
                let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                        confirmButtonText: this.language_terms['YES'],
                        cancelButtonText: this.language_terms['CANCEL'],
                        type: 'warning'
                    }).catch(() => {
                    this.$message.info(this.language_terms['ACTION_CANCEL'])
                })

                if(response === 'confirm')
                {
                    let payload = {salechannel_id:this.salechannel.id, contact_id:row.contact_id} 
                    await this.$store.dispatch("salechannels/removeCustomer", payload)

                    if(this.is_customer_removed)
                    {
                        // Call the api
                        await this.$store.dispatch("salechannels/fetch", {code:this.$route.params.id});
                        this.salechannel = this.salechannel_data
                    }

                }
                        

           }
        },
        async retrieveSaleChannel(code)
        {
            this.loading = true
            await this.$store.dispatch("salechannels/fetch", {code:code});
            this.loading = false

        },
        async addcustomer()
        {
            await this.$store.dispatch("salechannels/addCustomer", {salechannel_id:this.salechannel.id,contact_id:this.selected_customer.id});
            if(this.salechannel_added)
            {
                // Call the api
                await this.$store.dispatch("salechannels/fetch", {code:this.$route.params.id});
                this.salechannel = this.salechannel_data

                this.selected_customer = {}
            }
        }
    }    
}
</script>
